module.exports = __webpack_public_path__ + "img/idCompilanceCheck.1ee7c410.svg";